export default "__VITE_ASSET__Brs5iiVl__"